import { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
import moment from "moment";
// Styles
import "../../../Style/pagestyle.scss";
//Components
import EmptyData from "../../Include/EmptyData/EmptyData";
import LoadingPage from "../../../Utils/LoadingPage";
import CheckHomework from "./CheckHomework";
import HomeworkHeader from "./HomeworkHeader";
import RemarkHomework from "./RemarkHomework";
import ExerciseHomework from "./ExerciseHomework";
import {
  SelectClassByStudentId,
  SelectSubject,
} from "../../Include/DynamicSelect/DynamicSelect";

// Hooks & Context
import useGetHomeworkByStudent from "../../../Hooks/useGetHomeworkByStudent";
import { AuthContext } from "../../../Context/AuthContext";

export default function HomeworkForStudent({ studentId }) {
  // Context & Localization
  const { t, language } = useContext(AuthContext);

  // console.log("studentIdDDDD::", studentId)

  const [classVal, setClassVal] = useState({ id: "", title: "" });
  const [subject, setSubject] = useState({ id: "", title: "" });

  // Fetching homework data
  const { loading, tableData } = useGetHomeworkByStudent({
    studentId,
    classId: classVal?.id || "",
    subjectId: subject?.id || "",
  });

  // console.log("tableData", loading, tableData);

  // Track window width for responsive table
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const updateDimensions = () => setWidth(window.innerWidth - 50);
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container ">
      {/* Filters & Header Section */}
      <Box>
        <Grid container spacing={3}>
          {/* Subject Selector */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_class")}
            </Typography>
            <SelectClassByStudentId
              value={classVal}
              studentId={studentId}
              onChange={setClassVal}
              className="text-field"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={2.5} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_subject")}
            </Typography>
            <SelectSubject
              buttonAdd={false}
              value={subject}
              // classId={classId}
              onChange={setSubject}
              className="text-field"
            />
          </Grid>

          {/* Homework Summary Header */}
          <Grid item xs={12} sm={12} md={12} lg={6.5} xl={7}>
            <HomeworkHeader tableData={tableData} />
          </Grid>
        </Grid>
      </Box>

      {/* Homework Table Section */}
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            {/* Table Head */}
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("thead_no")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width="15%"
                  align="center"
                >
                  {t("thead_date")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_subject")}
                </TableCell>
                <TableCell
                  width="16%"
                  align="center"
                  className={t("class-name-header-title")}
                >
                  {t("thead_exercise")}
                </TableCell>

                <TableCell
                  width="25%"
                  align="center"
                  className={t("class-name-header-title")}
                >
                  {t("thead_status")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width="25%"
                  align="center"
                >
                  {t("thead_reason")}
                </TableCell>
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody className="body">
              {loading ? (
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              ) : tableData?.studentHomework?.length > 0 ? (
                tableData.studentHomework?.map((row, index) => (
                  <TableRow key={index} className="body-row">
                    <TableCell className="body-cell-start">
                      {index + 1}
                    </TableCell>

                    <TableCell className="body-cell" align="center">
                      {moment(row?.checkDate).format("DD MMM YYYY")}
                    </TableCell>

                    <TableCell className="body-cell">
                      {language === "en"
                        ? row?.subjectId?.enName
                        : row?.subjectId?.khName}
                    </TableCell>

                    <TableCell className="body-cell" align="center">
                      <ExerciseHomework editData={row} />
                    </TableCell>

                    <TableCell className="body-cell" align="center">
                      <CheckHomework editData={row} />
                    </TableCell>

                    <TableCell className="body-cell-end" align="right">
                      <RemarkHomework editData={row} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <EmptyData />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
